// extracted by mini-css-extract-plugin
export default {"cls1":"SimplePaperPodcast-cls1__8m","cls2":"SimplePaperPodcast-cls2_j_O SimplePaperPodcast-cls1__8m"};